import { render, staticRenderFns } from "./Silences.vue?vue&type=template&id=804508d0"
import script from "./Silences.vue?vue&type=script&lang=js"
export * from "./Silences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports